import { api, api2 } from './api.js';
import './browser-md5-file.min.js';

// TODO:是否做成全局持久
var fileList = [];
var runCount = 0; // 当前并行的上传
var setting = {};

var toast = window.yxpapi.utils.toast;
if (window.Vue && window.Vue.prototype.$message) {
    toast = window.Vue.prototype.$message;
}

//  上传文件
function postFile (param, options) {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        var preFile = param.rawFile;
        const fileType = Object.prototype.toString.call(param.rawFile);
        if (fileType === '[object File]' || fileType === '[object Blob]') {
            if (fileType === '[object Blob]') {
                preFile = new File([param.rawFile], param.rawFile.name, {
                    type: param.rawFile.type,
                });
            }
            // for (const p in rawFile) {
            //     if (rawFile.hasOwnProperty(p)) {
            //         preFile[p] = rawFile[p];
            //     }
            // }
            if (param.uploadType === 1) {
                api.apis.upload.url = param.signatureInfoAli.host;
                formData.append('key', param.signatureInfoAli.objectFull);
                formData.append('policy', param.signatureInfoAli.policy);
                formData.append('OSSAccessKeyId', param.signatureInfoAli.accessId);
                formData.append('signature', param.signatureInfoAli.signature);
                formData.append('success_action_status', 200);
            } else {
                api.apis.upload.url = param.signatureInfoAnoah.host;
                formData.append('moAuthorityToken', param.moAuthorityToken);
                formData.append('userId', param.userId);
            }
            formData.append('file', preFile);
            api.upload(formData, options).then(r => {
                // http请求出错
                if (r.errcode && r.errcode !== 0) {
                    toast({
                        message: r.errmsg,
                        duration: 1500,
                        showClose: true,
                        type: 'error',
                        onClose () {
                            resolve({ errcode: r.errcode, errmsg: r.errmsg });
                        },
                    });
                } else {
                    // http请求成功
                    resolve(true);
                }
            });
        } else {
            console.log('上传文件错误');
            resolve({ errcode: '-403', errmsg: '文件类型错误' });
        }
    });
}

/* 取授权返回
        md5Url:"https://proj289dev.anoah.com/upload/api2/jwt/Upload2/upload_md5/"
        moAuthorityToken: "b7cdca204f7b73a88b2293cf915cbf9f"
        up2appUrl: "?"
        uploadType: 1
*/
function getAuth ({ userId }) {
    let param = { userId };
    return api.uploadAuth(param);
}

// 取上传方式和地址
function getUploadUrl ({ fileMd5, fileName, userId, moAuthorityToken }) {
    let param = {
        fileMd5,
        fileName,
        userId,
        moAuthorityToken,
    };
    return api.uploadMd5(param);
}

// 计算md5
function getMd5 (itemFile) {
    var i = 0; // 计时器
    var sizePerSecond = 20 * 1024 * 1024 / 10; // 预计每秒处理容量，每秒20M
    return new Promise((resolve, reject) => {
        var getMd5Timer = setInterval(function () {
            i++;
            var progress = sizePerSecond * i / itemFile.rawFile.size;
            progress = progress > 1 ? 1 : progress;
            itemFile.progress = (Math.round((progress * 0.1 * 10000)) / 100).toFixed(1);
            // console.log('md5 progress', progress, itemFile.progress);
        }, 100);

        // 计算md5
        window.browserMD5File(itemFile.rawFile, (err, md5) => {
            getMd5Timer && clearInterval(getMd5Timer);
            if (err) {
                resolve({ 'status': false }, err);
            } else {
                itemFile.progress = (Math.round(0.1 * 10000) / 100).toFixed(1);
                resolve(md5);
            }
        });
    });
}

// 上传地址回传anoah
function uploadFinish ({ name, fileMd5, fileName, userId, moAuthorityToken, raw, signatureInfoToken }) {
    let param = {
        name,
        fileMd5,
        fileName,
        userId,
        moAuthorityToken,
        raw,
        signatureInfoToken,
    };
    return api.uploadFinish(param);
}

function fileUpload (itemFile) {
    var rawFile = itemFile.rawFile;
    var options = itemFile.options;

    return new Promise((resolve, reject) => {
        let uploadConfig = null;
        let formData = new FormData();
        var preFile = rawFile;
        console.log('rawFilerawFile', rawFile);
        const fileType = Object.prototype.toString.call(rawFile);
        if (fileType === '[object File]' || fileType === '[object Blob]') {
            if (fileType === '[object Blob]') {
                preFile = new File([rawFile], rawFile.name, {
                    type: rawFile.type,
                });
            }
            console.log('setting---', setting);
            if (setting.uploadConfig.length) {
                uploadConfig = getUploadConfig(rawFile);
            }
            if (uploadConfig) {
                api2.apis.fileUpload.url = (uploadConfig.uploadUrl || setting.uploadUrl) + (uploadConfig.uploadModeType || options.uploadModeType || 'avatar');
                if (uploadConfig.multimedia || options.multimedia) {
                    api2.apis.fileUpload.multimedia = uploadConfig.multimedia || options.multimedia;
                }
            } else {
                if (setting.uploadUrl) {
                    api2.apis.fileUpload.url = setting.uploadUrl + (options.uploadModeType || 'avatar');
                } else {
                    api2.apis.fileUpload.url = '/file/upload/' + (options.uploadModeType || 'avatar');
                }

                if (options.multimedia) {
                    api2.apis.fileUpload.multimedia = options.multimedia;
                }
            }

            formData.append('file', preFile);
            api2.fileUpload(formData, options).then(r => {
                itemFile.afterUploadedTimer && clearInterval(itemFile.afterUploadedTimer);
                resolve(r);
            });
        } else {
            console.log('上传文件错误');
            resolve({ errcode: '-403', errmsg: '文件类型错误' });
        }
    });
}

// 装载列表
function loadList (flist) {
    console.log('flist', flist);
    fileList = fileList.concat(flist);
    // flist.forEach((f2) => {
    //     getMd5(f2.rawFile).then(md5 => {
    //         alert(md5);
    //         f2.md5 = md5;
    //         let p = fileList.find((f1) => { return f1.md5 === f2.md5; });
    //         if (p) {
    //             f2 = p[0];
    //         } else {
    //             fileList.push(f2);
    //         }
    //     });
    // });
}

// 上传队列,重传排队时，flist不传
function uploadQuene (flist, opt) {
    if (opt) {
        setting = Object.assign({}, { index: 0, concurrency: 5, uploadUrl: '', uploadConfig: [] }, opt);
    }
    flist && loadList(flist);
    console.log('fileList', fileList);

    // 并发上传
    for (let i = setting.index; i < fileList.length; i++) {
        if (fileList[i].status === 'ready') {
            if (runCount >= setting.concurrency) {
                break;
            }
            uploadProcess(fileList[i]);
        }
    }
    return fileList;
}

// 找出一条准备上传的
function getReadyFile () {
    let nextItemFile = fileList.find(item => { return item.status === 'ready'; });
    console.log('nextItemFile', nextItemFile);
    return nextItemFile;
}

// // 取消上传
// function abort () {
//     typeof itemFile.cancle === 'function' && itemFile.cancle();
// }

// 上传一个文件
function uploadProcess2 (itemFile) {
    runCount++;
    var uploadType = '';
    var moAuthorityToken = '';
    var signatureInfoToken = '';
    // 已经上传过的执行下一条
    if (itemFile.status === 'succ') {
        let nextItemFile = getReadyFile();
        nextItemFile && uploadProcess2(nextItemFile);
        runCount--;
        return fileList;
    }

    itemFile.status = 'uploading';
    // 1,取授权地址
    getAuth({ 'userId': window.yxpapi.store.getters['global/userId'] }).then(auth => {
        console.log('1,授权', auth);
        if (auth.errcode === 0 || auth.errcode === 1) {
            uploadType = auth.data.uploadType;
            moAuthorityToken = auth.data.moAuthorityToken;
            // 2,取md5
            return itemFile.md5 || getMd5(itemFile);
        } else {
            itemFile.status = 'fail';
            itemFile.errMsg = '取授权地址失败';
            typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
            return false;
        }
    }).then((md5, errMsg) => {
        if (md5 === false) return false;
        console.log('2,算md5', md5);
        if (!md5.status) {
            itemFile.md5 = md5;
            let param = {
                fileMd5: md5,
                fileName: itemFile.rawFile.name,
                userId: window.yxpapi.store.getters['global/userId'],
                moAuthorityToken: moAuthorityToken,
            };
            // 3,过用md5和token取上传方式和地址
            return getUploadUrl(param);
        } else {
            itemFile.status = 'fail';
            itemFile.errMsg = errMsg;
            typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
            return false;
        }
    }).then(uploadUrl => {
        if (uploadUrl === false) return false;
        console.log('3,取上传地址或已经上传过的地址', uploadUrl);
        if (uploadUrl.errcode === 0) {
            // 以前上传过的
            let fi = uploadUrl.data.fileInfo || uploadUrl.data.file_info;
            if (fi && fi.hostOss) {
                itemFile.progress = 100;
                itemFile.status = 'succ';
                itemFile.errMsg = '';
                itemFile.downUrl = fi.hostStatic + fi.pathVirtual;
                itemFile.url = fi.hostOss + fi.pathPhysical;
                typeof itemFile.options.onSucc === 'function' && itemFile.options.onSucc(itemFile);
                return 'fileInfo';
            } else {
                // 4,上传
                let param = {
                    rawFile: itemFile.rawFile,
                    userId: window.yxpapi.store.getters['global/userId'],
                    moAuthorityToken: moAuthorityToken,
                    uploadType: uploadType,
                };
                signatureInfoToken = uploadUrl.data.signatureInfoToken;
                Object.assign(param, uploadUrl.data);
                let tmpOption = {
                    'onUploadProgress': (p) => {
                        itemFile.progress = (Math.round((p.loaded / p.total * 0.85 + 0.1) * 10000) / 100).toFixed(1);
                        typeof itemFile.options.onProgress === 'function' && itemFile.options.onProgress(itemFile);
                    },
                    cancel: null,
                };
                Object.assign(itemFile.options, tmpOption);
                itemFile.status = 'uploading';
                return postFile(param, itemFile.options);
            }
        } else {
            itemFile.status = 'fail';
            itemFile.errMsg = uploadUrl.errmsg;
            typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
            return false;
        }
    }).then(postResult => {
        if (postResult === false) return false;
        console.log('4,上传返回', postResult);
        if (postResult !== 'fileInfo') {
            itemFile.status = 'postSucc';
            let param = {
                name: itemFile.rawFile.name,
                fileMd5: itemFile.md5,
                fileName: itemFile.rawFile.name,
                userId: window.yxpapi.store.getters['global/userId'],
                moAuthorityToken: moAuthorityToken,
                signatureInfoToken: signatureInfoToken,
            };
            return uploadFinish(param);
        } else {
            return postResult;
        }
    }).then(finish => {
        if (finish !== false) {
            console.log('5,保存返回', finish);
            if (finish && finish.errcode === 0) {
                itemFile.progress = 100;
                itemFile.status = 'succ';
                itemFile.downUrl = finish.data.hostStatic + finish.data.pathVirtual;
                itemFile.url = finish.data.hostOss + finish.data.pathPhysical;
                typeof itemFile.options.onSucc === 'function' && itemFile.options.onSucc(itemFile);
            } else if (finish === 'fileInfo') {
            } else {
                itemFile.status = 'fail';
                itemFile.errMsg = '上传失败';
                typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
            }
        }
        runCount--;
        let nextItemFile = getReadyFile();
        nextItemFile && uploadProcess2(nextItemFile);
    });

    return fileList;
};

// 上传一个文件
function uploadProcess (itemFile) {
    runCount++;
    // 已经上传过的执行下一条
    if (itemFile.status === 'succ') {
        let nextItemFile = getReadyFile();
        nextItemFile && uploadProcess(nextItemFile);
        runCount--;
        return fileList;
    }

    itemFile.afterUploadedCount = 0; // 计时器
    var sizePerSecond = 20 * 1024 * 1024 / 10; // 预计每秒处理容量，每秒20M
    itemFile.afterUploaded = function (p) {
        if (p.loaded / p.total >= 1) {
            itemFile.afterUploadedTimer = setInterval(function () {
                itemFile.afterUploadedCount++;
                var progress = sizePerSecond * itemFile.afterUploadedCount / itemFile.rawFile.size;
                progress = progress > 1 ? 0.99 : progress;
                itemFile.progress = (Math.round((progress * 0.05 + 0.95) * 10000) / 100).toFixed(1);
                // console.log('afterUploaded', progress, itemFile.progress);
            }, 100);
        }
    };

    var fixedOptions = {
        'onUploadProgress': (p) => {
            let r = (Math.round((p.loaded / p.total * 0.85 + 0.1) * 10000) / 100);
            itemFile.progress = r >= 95 ? 95 : r.toFixed(1);
            typeof itemFile.afterUploaded === 'function' && itemFile.afterUploaded(p);
            typeof itemFile.options.onProgress === 'function' && itemFile.options.onProgress(itemFile);
        },
        setCancel: (c) => { itemFile.options.cancel = c; },
    };
    Object.assign(itemFile.options, fixedOptions);
    itemFile.status = 'uploading';

    new Promise((resolve, reject) => {
        if (itemFile.md5) {
            resolve(itemFile.md5);
        } else {
            getMd5(itemFile).then(md5 => {
                resolve(md5);
            });
        }
    }).then((md5, errMsg) => {
        if (md5 === false) return false;
        console.log('1,算md5', md5);
        if (!md5.status) {
            itemFile.md5 = md5;
            // 3,过用md5和token取上传方式和地址
            console.log('itemFile', itemFile);
            return fileUpload(itemFile);
        } else {
            itemFile.status = 'fail';
            itemFile.errMsg = errMsg;
            typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
            return false;
        }
    }).then(r => {
        console.log('2,上传', r);
        itemFile.afterUploadedCount = 0;
        if (r.errcode === 0) {
            itemFile.progress = 100;
            itemFile.status = 'succ';
            itemFile.downUrl = r.data.fileUrl + '?withOriginName=true&download=true';
            itemFile.url = r.data.fileUrl;
            itemFile.result = r.data;
            typeof itemFile.options.onSucc === 'function' && itemFile.options.onSucc(itemFile);
        } else {
            itemFile.status = 'fail';
            if (r.errcode === 1999) {
                itemFile.status = 'cancel';
            }
            itemFile.errMsg = r.errmsg;
            itemFile.progress = 0;
            itemFile.result = {};
            typeof itemFile.options.onFail === 'function' && itemFile.options.onFail(itemFile);
        }

        runCount--;
        let nextItemFile = getReadyFile();
        nextItemFile && uploadProcess(nextItemFile);
    });
}

// 上传配置
function getUploadConfig (file) {
    let fileName = file.name;
    let extName = fileName.substr(fileName.lastIndexOf('.') + 1);
    let uploadConfig = setting.uploadConfig.find(r => {
        let acc = r.accept.toLowerCase();
        acc = acc.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
        acc = acc.split(',');
        return acc.includes(extName.toLowerCase());
    });
    // uploadConfig:
    // {
    //     accept: '.mp4',
    //     uploadModeType: 'task/taskVideo',
    //     multimedia: '{"fileType":"video","parseThumbnail":1,"compress":1,"parseMetadata":1,"parseCoverIcon":1}',
    //     maxSize: 1024 * 10,
    // },
    return uploadConfig;
}
export { uploadProcess, uploadQuene, getMd5, uploadProcess2 };
